import React from "react";
import CourseNoteList from "../../components/content/course-note/course-note-list/CourseNoteList";

export default class CourseNoteListRoute extends React.PureComponent<{
    courseId?: string | null;
    categoryId?: string | null;
}> {
    render(): React.ReactNode {
        const { courseId, categoryId } = this.props;

        if (courseId == null || categoryId == null) {
            return null;
        }

        return (
            <CourseNoteList
                courseId={Number(courseId)}
                categoryId={Number(categoryId)}
            />
        );
    }
}
